
import { Link } from 'react-router-dom';

export default function CtaSection() {
  return (
    <section className="py-16 sm:py-20 bg-gradient-to-br from-primary to-red-700 text-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl sm:text-4xl font-bold mb-4 sm:mb-6">
          ¿Necesitas vaciar un piso o local en Vic?
        </h2>
        <p className="text-base sm:text-lg mb-8 sm:mb-10 opacity-95 leading-relaxed">
          Contacta con nosotros ahora y obtén un <strong>presupuesto sin compromiso</strong> para el vaciado de tu piso, local o trastero. Servicio profesional, discreto y urgente disponible 24 horas en Vic, Manlleu, Torelló y toda la comarca de Osona. Si tienes dudas, consulta nuestras <Link to="/faq" className="underline hover:text-secondary font-semibold">preguntas frecuentes</Link>.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="tel:+34602365996"
            className="bg-white text-primary px-6 sm:px-8 py-3 sm:py-4 rounded-lg font-semibold hover:bg-gray-100 transition-all duration-300 shadow-lg hover:shadow-xl text-sm whitespace-nowrap inline-flex items-center justify-center"
            aria-label="Llamar a JUSTCLEAN VIC"
          >
            <i className="ri-phone-line mr-2" aria-hidden="true"></i>
            Llamar: 602 36 59 96
          </a>
          <Link
            to="/contacto"
            className="bg-dark text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg font-semibold hover:bg-gray-800 transition-all duration-300 shadow-lg hover:shadow-xl text-sm whitespace-nowrap inline-flex items-center justify-center"
            aria-label="Ir al formulario de contacto"
          >
            <i className="ri-mail-line mr-2" aria-hidden="true"></i>
            Solicitar presupuesto
          </Link>
        </div>
      </div>
    </section>
  );
}
